var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"accessible-map d-flex flex-column p-0 m-0",style:({fontSize : _vm.displayFontSize }),attrs:{"fluid":""}},[_c('nav-bar'),_c('router-view'),_c('mobile-map',{directives:[{name:"show",rawName:"v-show",value:(_vm.showMap),expression:"showMap"}],key:`map_for_${_vm.tma}`,attrs:{"tma":_vm.tma}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }